import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { WHATSAPP_DISPLAY } from '../../../config/site';

const HeroSection = ({ onWhatsAppClick }) => (
  <section className="relative isolate overflow-hidden py-16 lg:py-24">
    <span className="aurora left-[-10%] top-[-4%] h-[26rem] w-[26rem] bg-trust-blue/30" aria-hidden="true" />
    <span className="aurora right-[-8%] top-[16%] h-[26rem] w-[26rem] bg-royal-gold/25" aria-hidden="true" />
    <div className="absolute inset-0 grid-lines" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
        <div className="animate-rise text-center lg:text-left">
          <span className="badge-pill mx-auto lg:mx-0">
            <Icon name="Crown" size={13} /> Since 2019 · the Nitin dynasty
          </span>

          <h1 className="mt-6 font-heading text-hero font-bold text-white [text-wrap:balance]">
            Built by players, <span className="gold-text">for players</span>
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-body-lg text-white/65 lg:mx-0">
            Nitin Online Book began with one stubborn idea: an Indian gaming platform should actually answer when you
            message it. Years later the Nitin Online Book desk still replies in under two minutes, and withdrawals
            still clear in about five. Everything else we built grew out of that single promise.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {[
              { v: '2019', l: 'Founded' },
              { v: '50,000+', l: 'Players served' },
              { v: '₹100Cr+', l: 'Secure payouts' },
              { v: '99.2%', l: 'Satisfaction' },
            ].map((s) => (
              <div key={s.l} className="stat-3d">
                <div className="font-display text-xl font-bold gold-text">{s.v}</div>
                <div className="mt-1 text-[0.6rem] uppercase tracking-[0.14em] text-white/45">{s.l}</div>
              </div>
            ))}
          </div>

          <div className="mt-9 flex flex-col items-center gap-4 sm:flex-row lg:justify-start">
            <button onClick={onWhatsAppClick} className="btn-3d btn-3d-wa w-full sm:w-auto">
              <FaWhatsapp size={19} /> Talk to a gaming expert
            </button>
            <span className="text-sm text-white/45">Direct line · {WHATSAPP_DISPLAY}</span>
          </div>
        </div>

        <div className="perspective relative mx-auto w-full max-w-md">
          <div className="panel-gold shine relative overflow-hidden rounded-[28px] p-8 text-center">
            <div className="relative mx-auto mb-6 flex h-28 w-28 items-center justify-center">
              <span className="absolute inset-0 animate-spin-slow rounded-full border-2 border-dashed border-royal-gold/40" />
              <span className="absolute inset-3 rounded-full bg-royal-gold/15 blur-lg" />
              <img src="/assets/images/logo.png" alt="Nitin Online Book crest" className="relative h-20 w-20 rounded-full object-contain" />
            </div>

            <h2 className="font-heading text-2xl font-bold gold-text">The Royal Promise</h2>
            <p className="mt-3 text-sm text-white/60">
              Fair games. Fast money. Real humans. If we ever break one of those three, message the desk and we fix
              it the same day.
            </p>

            <div className="divider-glow my-6" />

            <div className="space-y-3 text-left">
              {[
                { icon: 'ShieldCheck', text: 'Audited RNG and studio-dealt tables', color: '#25D366' },
                { icon: 'Zap', text: 'Withdrawals averaging 4m 51s, 24×7', color: '#F0C24B' },
                { icon: 'HeartHandshake', text: 'Responsible gaming tools on request', color: '#5B8CFF' },
              ].map((r) => (
                <div key={r.text} className="flex items-center gap-3 rounded-xl border border-white/8 bg-white/[0.04] px-4 py-3">
                  <Icon name={r.icon} size={17} color={r.color} />
                  <span className="text-sm text-white/70">{r.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
